import { PersonalEffectsQuotation } from "./components";

export const StepThree = () => <PersonalEffectsQuotation />;